// Интерфейс для конфигурации периодов
interface PeriodConfig {
  dayRanges: Array<{
    rangeStart: number;
    rangeEnd: number;
    period: number;
  }>;
}

// Константа с настройками периодов
export const PERIOD_CONFIG: PeriodConfig = {
  dayRanges: [
    { rangeStart: 5, rangeEnd: 7, period: 14 },
    { rangeStart: 10, rangeEnd: 20, period: 30 },
    { rangeStart: 25, rangeEnd: 35, period: 60 },
    { rangeStart: 55, rangeEnd: 65, period: 120 },
    { rangeStart: 115, rangeEnd: 125, period: 365 },
    { rangeStart: 360, rangeEnd: 370, period: 1095 },
    { rangeStart: 1000, rangeEnd: 1100, period: 0 },
  ],
};
